// extracted by mini-css-extract-plugin
export default {"background":"styles_background__VOHvp","container":"styles_container__+cvoj","wrapper":"styles_wrapper__MVJqS","title":"styles_title__cwzNC","text":"styles_text__9vY4d"};